module.exports = __webpack_public_path__ + "images/icon_post_review_53671eb4b7ba235cb4b5cce5acd55127.webp";